import type { MutationConfig } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { useMutation } from "react-query";
import { useGetSlug } from "../store/use-config";
import { GroupActionsOrderingRepository } from "./group-actions-ordering.api";
import type { CreateOrderErrorResponse } from "./group-actions-ordering.types";

const groupActionsOrderingRepository = new GroupActionsOrderingRepository();

type UseCreateOrderOptions = {
  config?: MutationConfig<typeof groupActionsOrderingRepository.createOrder, AxiosError<CreateOrderErrorResponse>>;
};

export const useCreateOrder = ({ config }: UseCreateOrderOptions) => {
  const slug = useGetSlug();

  return useMutation({
    ...config,
    mutationFn: (data) => groupActionsOrderingRepository.createOrder(data, slug),
  });
};
